import qs from 'qs';
import pick from 'lodash/pick';
import difference from 'lodash/difference';

import '!!style-loader!css-loader!sass-loader!./scss/index.scss';
import { getQueryParams } from '../../../common/libs/browsers';

//set in embed script
const SCRIPT_TAG_ID = 'scorestream-iframe';

// const currentScript = document.getElementById(SCRIPT_TAG_ID);
// const queryAttrRegex = /^query_(.*)/;
const extractedQueryParams = [
	'gameId',
	'teamId',
	'userWidgetId',
	'widgetType',
];

const omittedDataAttrs = [
	'src',
	'ss_widget_type',
	'widgetData'
];

function parseValue (val) {
	try {
		return JSON.parse(val);
	} catch (e) {
		return val;
	}
}

[...document.getElementsByClassName('scorestream-widget-container')]
	.filter(el => el.dataset.ss_widget_type && el.dataset.src)
	.forEach(/**@type HTMLElement*/el => {
		const ifr = document.createElement('iframe');
		ifr.classList.add('scorestreamIframe');
		let src = el.dataset.src;
		let widgetData = difference(Object.getOwnPropertyNames(el.dataset), omittedDataAttrs)
			.reduce((acc, attr) => ({
				...acc,
				[attr]: parseValue(el.dataset[attr]),
			}), pick(getQueryParams(), extractedQueryParams));
		if (el.dataset.widgetData) {
			widgetData = {
				...parseValue(el.dataset.widgetData),
				...widgetData,
			};
		}

		const query = pick(widgetData, extractedQueryParams);
		if (Object.keys(widgetData).length) {
			const dataStr = JSON.stringify(widgetData);
			if (dataStr.length > 2000) {
				//crazy long widgetData blows up the url, so widgets that could have ridiculous amounts of data should be set up to receive their widgetData over a message
				const link = document.createElement('a');
				link.href = src;
				ifr.onload = () => {
					ifr.contentWindow.postMessage({widgetData}, `${link.protocol}//${link.hostname}${(link.port) ? `:${link.port}` : ''}`);
				};
				query.widgetData = JSON.stringify({
					asyncWidgetData: true,
				});
			} else {
				query.widgetData = dataStr;
			}
		}
		if (Object.keys(query).length) {
			src += '?' + qs.stringify(query);
		}

		if (el.childElementCount && el.firstElementChild.src !== src) {
			el.removeChild(el.firstChildElement);
		}
		if (!el.childElementCount || el.firstElementChild.src !== src) {
			ifr.src = src;
			el.appendChild(ifr);
		}
	});
